module.exports = __webpack_public_path__ + "img/index27.52f77f5e.png";